import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

// 页面路由(独立页面)
export const pageRoutes = [
  // {
  //   path: '/404',
  //   component: () => import('@/views/pages/404'),
  //   name: '404',
  //   meta: { title: '404未找到' },
  //   beforeEnter (to, from, next) {
  //     // 拦截处理特殊业务场景
  //     // 如果, 重定向路由包含__双下划线, 为临时添加路由
  //     if (/__.*/.test(to.redirectedFrom)) {
  //       return next(to.redirectedFrom.replace(/__.*/, ''))
  //     }
  //     next({ ...to, replace: true })
  //   }
  // },
  { path: '/', component: () => import('@/pages/index/index'), name: 'index', meta: { title: '首页' } },
  { path: '/private', component: () => import('@/pages/private/private'), name: 'private', meta: { title: '隐私协议' } }
]

const router = new Router({
  mode: 'hash',
  scrollBehavior: () => ({ x: 0, y: 0 }),
  routes: pageRoutes
})

export default router